import { InputAdornment } from "@mui/material";
import InputField from "./InputField";

interface NumberFieldProps {
  value?: number | null;
  /** Called with the parsed number, or undefined when the input is empty */
  onChange?: (value: number | undefined) => void;
  min?: number;
  max?: number;
  /** Decimal places allowed (0 = integers only) */
  precision?: number;
  prefix?: string;
  suffix?: string;
  width?: number | string;
  disabled?: boolean;
  placeholder?: string;
}

/** Common numeric input: InputField with number parsing, so it works as an antd Form.Item child holding a number. */
const NumberField = ({ value, onChange, min, max, precision, prefix, suffix, width, disabled, placeholder }: NumberFieldProps) => (
  <InputField
    type="number"
    fullWidth={width === undefined}
    disabled={disabled}
    placeholder={placeholder}
    value={value ?? ""}
    sx={width === undefined ? undefined : { width }}
    inputProps={{ min, max, step: precision ? 1 / 10 ** precision : 1 }}
    startAdornment={prefix ? <InputAdornment position="start">{prefix}</InputAdornment> : undefined}
    endAdornment={suffix ? <InputAdornment position="end">{suffix}</InputAdornment> : undefined}
    onChange={(e) => onChange?.(e.target.value === "" ? undefined : Number(e.target.value))}
  />
);

export default NumberField;
